export default __webpack_public_path__ + "static/media/MC.b1b242c1.svg";